var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    role: "img",
    "aria-label": "Delete",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 6V4a3 3 0 0 1 3-3h2a3 3 0 0 1 3 3v2h4a1 1 0 1 1 0 2h-1.1l-1.02 12.24A3 3 0 0 1 15.89 23H8.11a3 3 0 0 1-3-2.76L4.1 8H3a1 1 0 1 1 0-2h5Zm2 0h4V4a1 1 0 0 0-1-1h-2a1 1 0 0 0-1 1v2Zm-1.9 4.1a1 1 0 1 1 2 0v6.8a1 1 0 1 1-2 0v-6.8Zm6.8 0a1 1 0 1 1 2 0v6.8a1 1 0 1 1-2 0v-6.8Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.ea384729ca189c59f07dff4640f56f4d.svg";
export { ForwardRef as ReactComponent };